import { render, staticRenderFns } from "./financeBuy.vue?vue&type=template&id=2b48bacb"
import script from "./financeBuy.vue?vue&type=script&lang=js"
export * from "./financeBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports